import { InMemoryObjectBase } from '../../../helpers/in-memory-object';
import { JSONUtilites } from '../../../helpers/JSONUtilites';
import { PartnerRelationship } from './parent-relationship';

export class InMemoryPartnerRelationships extends InMemoryObjectBase<PartnerRelationship> {

  get(partnerRelationshipId: number): PartnerRelationship {
    return this._items.find(x => x.partnerId === partnerRelationshipId);
  }

  protected get storeKeyName(): string {
    return 'in_memory_partner_relationship';
  }

  protected _createDemoItems(): PartnerRelationship[] {
    return [new PartnerRelationship({ partnerId: 2, childrenIds: [4, 5] })];
  }

  protected _FromJSON(json: string): PartnerRelationship[] {
    return JSONUtilites.arrayFromJSON(PartnerRelationship, json);
  }

  protected _getItemId(item: PartnerRelationship): number {
    return item.partnerId;
  }
}

